const initCardComponent = () => {
    const configCardsAnimation = new ConfigCardsAnimation();
    configCardsAnimation.delay = 300;
    const cardAnimation = new CardAnimation;
    cardAnimation.initCardsAnimation(configCardsAnimation);
};
